import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { DocTableHeader } from '../common';
import Document from './../../../components/document';
import { DocumentInfo, PERMISSIONS } from '../../../utilities/documentTypes';
import messages from '../../../text/messages';

class ClientDocuments extends React.Component {
    render() {
        return (
            <div>
                <div className="row section">
                    <div className="col-xs-8">
                        <FormattedMessage id={'documents.clientUpload'} defaultMessage={'Documents for use by your workers.'} />
                    </div>
                </div>

                <div className="row">
                    <DocTableHeader />
                </div>

                <div className="manage-documents">
                    <div className="row section">
                        <div className="col-xs-12">
                            {DocumentInfo.clientDocuments.map((doc, i) => (
                                <div key={i}>
                                    <Document
                                        id={`${doc.docType}${i}`}
                                        upload={{
                                            button: onOpen => (
                                                <div className="table-row">
                                                    <div className="row">
                                                        <div className="col-xs-12">
                                                            <div className="col-xs-8 column-name ellipsis">
                                                                <FormattedMessage {...messages.upload} /> {doc.displayName}
                                                            </div>
                                                            <div className="col-xs-4 text-right">
                                                                <button className="btn btn-sm btn-success" type="button" onClick={onOpen}>
                                                                    <FormattedMessage {...messages.upload} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                            limit: doc.limit,
                                            permissions: PERMISSIONS.DEFAULT
                                        }}
                                        {...doc}
                                        view={{ showHeader: false }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ClientDocuments.defaultProps = {
    role: undefined
};
ClientDocuments.propTypes = {
    role: PropTypes.object.isRequired
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ClientDocuments);



// WEBPACK FOOTER //
// ./src/pages/documents/tenants/client.jsx